import { render, staticRenderFns } from "./ViewOwnerShip.vue?vue&type=template&id=c5737332"
import script from "./ViewOwnerShip.vue?vue&type=script&lang=js"
export * from "./ViewOwnerShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports